import React from 'react'
import { Columns, Column } from 'react-flex-columns'
import DataTable from 'shared/ui/DataTable'
import Icon from 'shared/ui/Icon'
import FocusedHeader from './FocusedHeader'

export default function ReviewRegistrations({ send, context: { attendees } }) {
  return (
    <div className="spacing">
      <FocusedHeader>Review Attendees</FocusedHeader>
      <DataTable>
        <tbody>
          {attendees.map((attendee, index) => (
            <tr key={index}>
              <td>{attendee.name}</td>
              <td>{attendee.email}</td>
            </tr>
          ))}
        </tbody>
      </DataTable>
      <Columns as="footer" split middle>
        <Column>
          <button onClick={() => send('CHANGE')} className="icon-text">
            <Icon name="arrow-left" />
            <span>Edit Attendees</span>
          </button>
        </Column>
        <Column>
          <button onClick={() => send('APPROVE')} className="button icon-text">
            <span>Looks Good, Continue to Checkout</span>
            <Icon name="arrow-right" size={2} />
          </button>
        </Column>
      </Columns>
    </div>
  )
}
